/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1SsoimageIdMutationResponse,
  DeleteApiV1SsoimageIdPathParams,
  DeleteApiV1SsoimageId400,
  DeleteApiV1SsoimageId401,
  DeleteApiV1SsoimageId500,
} from "../../types/SSOImageController/DeleteApiV1SsoimageId.ts";

function getDeleteApiV1SsoimageIdUrl(
  id: DeleteApiV1SsoimageIdPathParams["id"],
) {
  const res = { method: "DELETE", url: `/api/v1/ssoimage/${id}` as const };
  return res;
}

/**
 * @description Desativa uma SSOImage e todos os seus idiomas. **(Requer Authorization para autenticação)**
 * @summary Excluir imagem SSO (soft delete) (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id}
 */
export async function deleteApiV1SsoimageId(
  id: DeleteApiV1SsoimageIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageId400
      | DeleteApiV1SsoimageId401
      | DeleteApiV1SsoimageId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1SsoimageIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
